import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_3wjz3ymzpk: FaireCollectionEntity = {
  token: "pbc_3wjz3ymzpk",
  type: "collection",
  name: "Shorts and Skirts",
  heroImageUrl:
    "https://cdn.faire.com/fastly/616148fbb7309d44892eac5e07113e86732f38934d8f08b412fbb57f1dd360f8.jpeg",
  itemCount: 11,
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:14.797Z",
    importedBy: "entity-db-import-collections",
  },
};
